import * as yup from 'yup'

import { normalizeCpfCnpj } from '~/utils/cnpj'

export const schema = yup.object({
  documento: yup
    .string()
    .required('CPF/CNPJ é obrigatório')
    .test('cpf-cnpj', 'CPF ou CNPJ inválido', (value) => {
      if (!value) return true
      return /^([0-9]{11}|[0-9A-Z]{12}[0-9]{2})$/.test(normalizeCpfCnpj(value))
    }),
  estado: yup.number().required('Estado é obrigatório'),
})
